<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-row slot="title">
      <a-col :span="24">
        <span>数据统计</span>
        <span class="tips">
          <span v-if="dataForm.couponNumType==2">限{{ dataForm.couponNumLimit }}张,</span>
          <span v-else>{{ dataForm.couponNumTypeStr }},</span>
          已领{{ dataForm.count }}张,核销{{ dataForm.useCount }}张
        </span>
      </a-col>
    </a-row>
    <search-page-view
      ref="table"
      :col="4"
      rowKey="couponuserId"
      :itemNames="['search_cellPhone', 'search_useStatus', 'search_date']"
      :buttonItems="['download']"
      :columns="columns"
      :queryParams="queryParams"
      query-path="coupon/setting/getUserCouponList"
      base-key="serviceUrl"
    >
      <a-form-item slot="search_cellPhone" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.cellPhone" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_useStatus" label="类型" v-bind="searchItemLayout">
        <a-select allowClear
                  style="width: 100%"
                  v-model="queryParams.useStatus"
                  placeholder="请选择"
        >
          <a-select-option value="0">未使用</a-select-option>
          <a-select-option value="1">已使用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="search_date" label="日期" v-bind="searchItemLayout">
        <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
      </a-form-item>
      <a-button slot="download" style="margin-left: 8px" @click="exportData">导出</a-button>
      <div slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.couponuserUserName }}</div>
        <div>{{ rowItem.record.couponuserMobile }}</div>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'CouponStatics',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {
        couponId: this.$route.query.couponId,
        cellPhone: '',   //手机号码
        useStatus: undefined,// '是否领取，1，已领取 0未领取'
        endDate: '',   // '结束时间'
        startDate: ''  // '开始时间'
      },
      dataForm: {
        couponNumLimit: '',// 发放数量 ,
        couponNumType: '',// 数量发放类型（1，不限量，2，限量） ,
        couponNumTypeStr: '',
        unUseCount: '',// 未使用状态 ,
        useCount: ''// 已核销（使用）状态
      },
      couponId: this.$route.query.couponId,
      columns: [
        {
          title: '时间',
          dataIndex: 'couponuserCreateTime'
        },
        {
          title: '类型',
          dataIndex: 'couponuserUseStatusStr',
          width: '100px'
        },
        {
          title: '用户',
          dataIndex: 'couponuserUserName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '渠道',
          dataIndex: 'couponuserGetClientTypeStr',
          width: '100px'
        },
        {
          title: '入口',
          dataIndex: 'couponuserRemarks',
          width: '40%'
        }
      ],
      selectedDate: undefined
    }
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('优惠券activated')
    this.$store.commit('SET_RECHARGE', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CouponServiceList', title: '优惠券列表' },
      { name: 'CouponRuleList', title: '规则列表' }
    ])
    this.couponId = this.$route.query.couponId
    this.queryParams.couponId = this.$route.query.couponId
    this.getUserCouponCount()
    this.$refs.table.refresh(true)
  },
  methods: {
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.startDate = dateStrArr[0]//开始日期
      this.queryParams.endDate = dateStrArr[1]//结束日期
      this.getLogUtils().logWithTag('日期', dateStrArr)
    },
    // 获取信息
    getUserCouponCount() {
      this.getHttpServices().getServerApiService().post('coupon/setting/getUserCouponCount/' + this.couponId).then(res => {
        this.getLogUtils().logWithTag('==getUserCouponCount==', res)
        this.dataForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //导出
    exportData() {
      //去除null
      this.queryParams.endDate = this.queryParams.endDate ? this.queryParams.endDate : ''
      this.queryParams.startDate = this.queryParams.startDate ? this.queryParams.startDate : ''
      var url = this.getAppConfig().serviceUrl + 'coupon/exportUserCouponList?couponId=' + this.couponId + '&startDate=' + this.queryParams.startDate + '&endDate=' + this.queryParams.endDate + '&cellPhone=' + this.queryParams.cellPhone
      window.open(url)
    }
  }

}
</script>
<style scoped lang="less">
.tips {
  margin-left: 50px;
  font-size: 14px;
}
</style>